/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PROSUPPLIER", "112")


  
    
export interface API12540Item {
  
  /** 品牌描述  */
  brandDesc?: string;
  
  /** 品牌名称 */
  brandName?: string;
  
  /** 英文名 */
  brandNameEn?: string;
  
  /** 品牌编号 */
  brandNo?: string;
  
  /** 类目信息列表 */
  categoryInfoList?: API12540Item[];
  
  /** 国家 */
  country?: string;
  
  /** logo图片地址 */
  logo?: string;
  
};
    
  



export interface API12540Req {
  
  /** 叶子类目编号 */
  categoryNo?: string;
  /** 品牌名, 模糊查询 */
  brandName?: string;
};



export interface API12540Res {
  /**   */
  code?: number;
  /**   */
  data?: API12540Item[];
  /**   */
  msg?: string;
  /**   */
  success?: boolean;
  
};


// 12540 查询类目下品牌列表

export interface IUsePostAPI12540Return {
  /** 查询类目下品牌列表: 接口请求状态 */
  isAPI12540Loading: boolean;
  /** 查询类目下品牌列表: 接口请求返回数据 */
  dataAPI12540: API12540Res;
  /**  查询类目下品牌列表: 接口数据请求方法 */
  fetchAPI12540Data:  (inputs: API12540Req, config?: YWRequestConfig) => Promise<API12540Res>;
  /** 查询类目下品牌列表: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI12540 = ():IUsePostAPI12540Return => {
  let isMount = true;
  const [isAPI12540Loading, setIsAPI12540Loading] = useState(false);
  const [dataAPI12540, setDataAPI12540] = useState<API12540Res>({} as API12540Res);
  const requestUrl = `${basePath}/brand/category/list`;

  const fetchAPI12540Data = async (inputs: API12540Req, config?: YWRequestConfig): Promise<API12540Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API12540Req>) || {}) as API12540Req;
    
  
    if ( isMount ) {
      setIsAPI12540Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API12540Res>(`${basePath}/brand/category/list`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI12540(res || {} as API12540Res);
        setIsAPI12540Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI12540Loading(false);
      }
      return false as unknown as API12540Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI12540Loading,
    dataAPI12540,
    fetchAPI12540Data,
    requestUrl,
  }
}

